var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashBoardContent',{attrs:{"title":"應徵記錄"}},[_c('ApplyList',{attrs:{"details":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }